// @flow

import React from 'react'
import ReactDOM from 'react-dom'
import {IntlProvider, addLocaleData} from 'react-intl'
import EnblokksvisningWidgetContainer from '../../shared/containers/EnblokksvisningWidget'
import style from '../../shared/containers/EnblokksvisningWidget/style.css'

// Import locales
import nb from 'react-intl/locale-data/nb'
import nn from 'react-intl/locale-data/nn'
import en from 'react-intl/locale-data/en'

addLocaleData([...nb, ...nn, ...en])

const elms = Array.from(
  document.getElementsByClassName(style.enblokksvisningWidget)
)
const cache = (window.v17enblokksvisningCache =
  window.v17enblokksvisningCache || {})

elms.forEach(elm => {
  if (cache[elm.id]) return

  cache[elm.id] = true

  const propsRaw = elm.getAttribute('data-props')

  if (!propsRaw) {
    if (console && console.error) console.error('Missing data-props')
    return
  }

  const props = JSON.parse(decodeURIComponent(propsRaw))
  const mountNode = elm.parentNode

  if (!mountNode) {
    if (console && console.error) console.error('Missing mount node')
  }

  ReactDOM.render(
    <IntlProvider locale="nb" defaultLocale="nb">
      <EnblokksvisningWidgetContainer {...props} />
    </IntlProvider>,
    elm.parentNode
  )
})



// WEBPACK FOOTER //
// ./src/client/enblokksvisning/mount.js